
import {throwError as observableThrowError,  Observable } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../authentication/auth.service'
import { ConfigService } from '../config/config.service';
import { HttpClient, HttpHeaders} from '@angular/common/http'

@Injectable()
export class InvoiceService {

  constructor(
    private router: Router,
    private auth: AuthService,
    private config: ConfigService,
    private http: HttpClient
  ) { }

  getInvoiceOrders(data) {
    let httpOptions = {
      headers:new HttpHeaders({ 'Authorization': 'Bearer ' + this.auth.getToken() }),
    }
    let url = this.config.getBasePath() + '/invoice/getinvoice';      
    return this.http.post(url, data ,httpOptions).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => observableThrowError(error.error)),);
  }

  getOrderProducts(orderId) {
    let httpOptions = {
      headers:new HttpHeaders({ 'Authorization': 'Bearer ' + this.auth.getToken() }),
    }
    let url = this.config.getBasePath() + '/invoice/order/'+ orderId +'/orderProducts';
    return this.http.get(url, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => observableThrowError(error.error)),);
  }

  getInvoiceSpan() {
    let httpOptions = {
      headers:new HttpHeaders({ 'Authorization': 'Bearer ' + this.auth.getToken() }),
    }
    let url = this.config.getBasePath() + '/invoice/'+ this.auth.getUserId() +'/period/span';
    return this.http.get(url, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => observableThrowError(error.error)),);
  }

  private convertUTCToLocalDateString(utcDateString: string): string {
    const date = new Date(utcDateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

  generatePDF(data): Observable<Blob> {
    const processedData = {
        ...data,
        fromDate: this.convertUTCToLocalDateString(data.fromDate),
        toDate: this.convertUTCToLocalDateString(data.toDate)
    };
  let httpOptions = {
    headers: new HttpHeaders({ 
      'Authorization': 'Bearer ' + this.auth.getToken(),
      // CRITICAL: Remove Accept header that expects JSON/text
      // 'Accept': 'application/pdf'  // Don't set this - let it default
    }),
    responseType: 'blob' as 'json'
  }
  let url = this.config.getBasePath() + '/invoice/client/generatePDF';
  return this.http.post(url, processedData, httpOptions).pipe(
    map((response: any) => {
      return response as Blob;
    }),
    catchError((error: any) => {
      return observableThrowError(error.error || error);
    }),
  );
}
}